import React, { useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  IconButton,
  Button,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import ReportBillGenerator from './ReportBillGenerator';

const ReportBillModal = ({
  open,
  onClose,
  billId,
  ownerId,
  billType,
}) => {
  // Sync with browser history so hardware/browser back button closes this modal
  useEffect(() => {
    if (open) {
      window.history.pushState(
        { ...window.history.state, reportBillModal: true },
        ''
      );

      const handlePopState = (event) => {
        if (!event.state?.reportBillModal) {
          onClose();
        }
      };

      window.addEventListener('popstate', handlePopState);
      return () => {
        window.removeEventListener('popstate', handlePopState);
      };
    }
  }, [open]);

  const handleClose = () => {
    if (window.history.state?.reportBillModal) {
      window.history.back();
    } else {
      onClose();
    }
  };

  if (!open && !billId) return null;

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          bgcolor: '#f8fafc',
          overflowY: 'auto',
        },
      }}
    >
      {/* TOP HEADER BAR */}
      
      {/* BILL GENERATOR CONTENT */}
      <DialogContent sx={{ p: { xs: 1.5, sm: 3 } }}>
        <Box sx={{ maxWidth: '1200px', mx: 'auto' }}>
          <ReportBillGenerator
            billId={billId}
            ownerId={ownerId}
            billType={billType}
            onBack={handleClose}
            backButtonLabel="Back to Staff Details"
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ReportBillModal;

